<div class="flex flex-col h-screen overflow-hidden bg-slate-200">
  <!-- Click Ripple Burst Overlay -->
  <div *ngIf="showRipple" class="menu-click-ripple" [style.left.px]="rippleX" [style.top.px]="rippleY"></div>

  <div class="w-full z-50 bg-white shadow-sm relative flex-none">

    <app-header class="block px-4 py-2 text-white bg-green-700"></app-header>

    <div class="ncms-menu border-b border-gray-300 bg-white text-black relative">

      <div class="flex flex-wrap justify-between items-center px-4 py-2 min-h-[50px] relative gap-y-2">

        <div class="flex items-center gap-4 z-10 shrink-0">
          <button class="lg:hidden p-1 text-gray-700 hover:text-green-700 focus:outline-none"
            (click)="toggleMobileMenu()">
            <mat-icon>menu</mat-icon>
          </button>

          <button class="hidden lg:block text-gray-600 hover:text-green-700" (click)="toggleTaskSidebar()"
            title="Toggle Task Sidebar">
            <mat-icon>{{ isSidebarOpen ? 'first_page' : 'last_page' }}</mat-icon>
          </button>
        </div>

        <ul class="hidden lg:flex flex-wrap list-none items-center justify-center gap-x-6 gap-y-2 flex-1 px-4 z-10"
          (mouseenter)="keepMenuOpen()" (mouseleave)="hideSubMenu()">

          <li *ngFor="let menuItem of menuItems()" class="px-2 py-1 cursor-pointer relative group"
            (mouseenter)="toggleSubMenu(menuItem, $event)">

            <ng-container *ngIf="!menuItem.subMenu">
              <a (click)="navigateFromSearch(menuItem, $event)"
                class="font-medium hover:text-green-700 whitespace-nowrap transition-colors">
                {{ menuItem.label === 'My Assignments' ? ('Pending ' + (isSupremeCourtFlg ? 'Appeals' : 'Cases')) :
                menuItem.label }}
              </a>
            </ng-container>

            <span *ngIf="menuItem.subMenu"
              class="font-medium group-hover:text-green-700 flex items-center space-x-1 whitespace-nowrap transition-colors">
              {{ menuItem.label }}
              <mat-icon class="text-gray-500 text-[18px]">arrow_drop_down</mat-icon>
            </span>
          </li>
        </ul>

        <div class="flex items-center ml-auto z-10 shrink-0">
          <a [href]="oldVersionUrl" target="_blank" class="mr-4 text-sm font-semibold
                text-blue-600 visited:text-blue-600
                hover:underline hover:scale-105
                flex items-center gap-1
                transition-all duration-200">
            Use Old Version
          </a>
          <div #searchArea class="relative flex items-center">
            <input type="text" placeholder="Search Menu..." [(ngModel)]="globalSearch" (input)="filterGlobalMenu()"
              class="border border-gray-300 rounded-full px-4 py-1 text-sm focus:outline-none focus:ring-2 focus:ring-green-600 transition-all duration-300 w-32 sm:w-48 lg:w-64 focus:w-64" />

            <mat-icon class="absolute right-3 text-gray-400 text-sm pointer-events-none">search</mat-icon>

            <div *ngIf="searchResults.length > 0"
              class="absolute top-full right-0 mt-2 w-64 bg-white border border-gray-200 shadow-xl rounded-lg overflow-hidden z-[9999]">
              <div *ngFor="let item of searchResults"
                class="px-4 py-2 text-sm text-gray-700 hover:bg-green-50 hover:text-green-800 cursor-pointer border-b last:border-0 border-gray-100"
                (click)="navigateFromSearch(item, $event)">
                {{ item.fullLabel }}
              </div>
            </div>
          </div>

          <button class="lg:hidden ml-2 text-gray-700" (click)="toggleTaskSidebar()">
            <mat-icon>assignment</mat-icon>
          </button>
        </div>

      </div>
    </div>

    <div *ngIf="expandedMenu?.subMenu && !isMobile"
      class="mega-submenu bg-white border border-gray-200 rounded-b-2xl shadow-xl absolute w-full z-40 top-full left-0"
      (mouseenter)="keepMenuOpen()" (mouseleave)="hideSubMenu()">

      <!-- Pointer arrow -->
      <div
        class="absolute -top-2 w-4 h-4 bg-white border-l border-t border-gray-200 shadow-[-2px_-2px_4px_rgba(0,0,0,0.05)] transform rotate-45 transition-all z-50 pointer-events-none"
        [style.left.px]="arrowPosition - 8"></div>

      <div
        class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-6 p-6 container mx-auto items-start">
        <ng-container *ngFor="let sub of expandedMenu.subMenu">
          <!-- Main Sub Menu Column Container -->
          <div class="flex flex-col">
            <!-- Sub Menu Header -->
            <a *ngIf="sub.routerLink; else subNoLink" (click)="navigateFromSearch(sub, $event); hideSubMenu()"
              class="text-green-700 text-[15px] mb-3 hover:font-bold hover:text-green-800 hover:underline">
              {{ sub.label }}
            </a>
            <ng-template #subNoLink>
              <div *ngIf="sub.subMenu?.length; else disabledSub" class="font-bold text-green-800 text-[15px] mb-3">{{
                sub.label }}</div>
              <ng-template #disabledSub>
                <div class="font-bold text-gray-400 text-[15px] mb-3 cursor-not-allowed">{{ sub.label }}</div>
              </ng-template>
            </ng-template>

            <!-- 3rd Level Menu Items Grid (max 7 per column) -->
            <div *ngIf="sub.subMenu?.length" class="flex gap-x-6">
              <div *ngFor="let chunk of getChunks(sub.subMenu, 5)" class="flex flex-col gap-1.5 w-full">
                <ng-container *ngFor="let child of chunk">
                  <a *ngIf="child.routerLink; else childNoLink"
                    (click)="navigateFromSearch(child, $event); hideSubMenu()"
                    class="text-gray-600 hover:text-green-800 hover:underline hover:bg-green-50 text-sm py-1 px-2 -mx-2 rounded transition-colors break-words">
                    {{ child.label }}
                  </a>
                  <ng-template #childNoLink>
                    <span class="text-gray-400 text-sm py-1 px-2 -mx-2 cursor-not-allowed break-words">{{ child.label
                      }}</span>
                  </ng-template>
                </ng-container>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

  </div>
  <div class="fixed inset-0 z-[100] flex lg:hidden" *ngIf="isMobileMenuOpen">
    <div class="fixed inset-0 bg-black bg-opacity-50 transition-opacity" (click)="toggleMobileMenu()"></div>

    <div class="relative bg-white w-64 h-full shadow-xl overflow-y-auto flex flex-col animate-slide-in">
      <div class="p-4 border-b flex justify-between items-center bg-green-700 text-white">
        <span class="font-bold text-lg">Menu</span>
        <button (click)="toggleMobileMenu()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="flex-1 py-2">
        <div *ngFor="let menuItem of menuItems()">
          <div
            class="px-4 py-3 border-b border-gray-100 flex justify-between items-center cursor-pointer hover:bg-gray-50"
            (click)="menuItem.subMenu ? toggleMobileSubMenu(menuItem.id) : navigateFromSearch(menuItem, $event)">
            <span [class.text-green-700]="menuItem.routerLink || mobileSubMenuId === menuItem.id"
              class="font-medium text-gray-800">
              {{ menuItem.label }}
            </span>
            <mat-icon *ngIf="menuItem.subMenu" class="text-gray-400 transition-transform"
              [class.rotate-180]="mobileSubMenuId === menuItem.id">
              expand_more
            </mat-icon>
          </div>

          <div *ngIf="mobileSubMenuId === menuItem.id && menuItem.subMenu" class="bg-gray-50 shadow-inner py-1">
            <ng-container *ngFor="let sub of menuItem.subMenu">
              <!-- Level 2 without children -->
              <a *ngIf="sub.routerLink && !sub.subMenu?.length" (click)="navigateFromSearch(sub, $event)"
                class="block pl-8 pr-4 py-2 text-sm text-gray-600 hover:text-green-700 border-l-4 border-transparent hover:border-green-500">
                {{ sub.label }}
              </a>

              <!-- Level 2 with children (3rd level) -->
              <div *ngIf="sub.subMenu?.length" class="flex flex-col mt-1 mb-2">
                <div class="px-8 py-1.5 text-[13px]  text-green-600 uppercase tracking-wide bg-green-50/50">
                  {{ sub.label }}
                </div>
                <ng-container *ngFor="let child of sub.subMenu">
                  <a *ngIf="child.routerLink" (click)="navigateFromSearch(child, $event); onMobileNavigate()"
                    class="block pl-12 pr-4 py-1.5 text-sm text-gray-600 hover:text-green-700 border-l-4 border-transparent hover:border-green-500">
                    {{ child.label }}
                  </a>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="flex flex-1 overflow-hidden relative">

    <div
      class="bg-white border-r border-gray-200 shadow-sm flex-none transition-all duration-300 absolute inset-y-0 left-0 z-30 lg:static lg:z-auto"
      [ngClass]="{'shadow-xl': isMobile}"
      [ngStyle]="{ width: isSidebarOpen ? (isMobile ? '80%' : sidebarWidth + 'px') : '0', opacity: isSidebarOpen ? 1 : 0, overflow: 'hidden' }">

      <div class="flex justify-end p-2 lg:hidden">
        <button (click)="toggleTaskSidebar()"><mat-icon>close</mat-icon></button>
      </div>

      <div class="h-full overflow-y-auto p-2">
        <app-assigned-tasks></app-assigned-tasks>
      </div>

      <div
        class="absolute top-0 right-0 w-1 h-full cursor-col-resize hover:bg-green-400 active:bg-green-600 z-40 hidden lg:block"
        (mousedown)="startResizing($event)">
      </div>
    </div>

    <div class="flex-1 overflow-y-auto bg-slate-100 p-4 relative w-full">
      <div *ngIf="isMobile && isSidebarOpen" class="absolute inset-0 bg-black bg-opacity-30 z-20"
        (click)="toggleTaskSidebar()">
      </div>
      <div #routeWrapper class="route-animation-wrapper" [class.animating]="isRouteAnimating"
        [style.--click-x.px]="clickX" [style.--click-y.px]="clickY">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>

</div>